import React from 'react';
import PropTypes from 'prop-types';
import { pointsLabel } from 'utils/meetPoints';

// How a meet scores, in the server's own words (PointsExplanation in the portal repo,
// docs/school-carnivals-points-slice-2.md): sections such as Finish Place Points, each a heading,
// an optional sentence before and after, and its lines ("1st place: 4 points"). Drawn the same way
// by the Meet Details points dialog and the Meet Points page's help, so the two always agree. Only
// ways that earn points are sent, so an empty list draws nothing.
const PointsExplanationList = ({ sections = [] }) => (
  <>
    {sections.map((section) => (
      <React.Fragment key={section.title}>
        <h3>{section.title}</h3>
        {section.intro && <p>{section.intro}</p>}
        <ul>
          {section.lines.map((line) => (
            <li key={line.label}>
              <strong>{line.label}:</strong> {pointsLabel(line.points)}
              {line.note ? <> — {line.note}</> : null}
            </li>
          ))}
        </ul>
        {section.note && <p>{section.note}</p>}
      </React.Fragment>
    ))}
  </>
);

PointsExplanationList.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      intro: PropTypes.string,
      lines: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          points: PropTypes.number.isRequired,
          note: PropTypes.string,
        })
      ).isRequired,
      note: PropTypes.string,
    })
  ),
};

export default PointsExplanationList;
